<script>
import { getServiceCodes } from '@/api/channel-api'
export default {
  name: 'ProductLineSelect',
  props: {
    value: {
      type: null,
      default: null,
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      selected: '',
      serviceLines: [],
    }
  },
  watch: {
    value: {
      handler(val) {
        this.selected = val
      },
      immediate: true,
    },
  },
  created() {
    this.getInfo()
  },
  methods: {
    change(val) {
      this.$emit('change', val)
      this.$emit('onChange', this.filterServiceCodes(val))
    },
    // 根据所选产品线过滤出serviceCodes
    filterServiceCodes(val) {
      return this.serviceLines.reduce(
        (result, item) => {
          if ((val === '' || val === item.appCode) && item.appCode !== '') {
            result = result.concat(item.serviceCodes)
            if (val !== '') return result // 如果找到匹配的appCode，提前返回结果
          }
          return result
        },
        [
          {
            serviceCode: '',
            serviceCodeName: '全部',
            serviceCodes: [],
          },
        ],
      )
    },
    async getInfo() {
      try {
        const {
          result: { result = [] },
        } = await getServiceCodes()
        this.serviceLines = [
          {
            appCode: '',
            appCodeName: '全部',
          },
        ].concat(result)
        this.$emit('onChange', this.filterServiceCodes(''))
      } catch (err) {
        console.log(err)
      }
    },
  },
}
</script>

<template>
  <div>
    <el-select v-model="selected" @change="change" clearable class="w-full">
      <el-option
        v-for="(item, index) in serviceLines"
        :label="item.appCodeName"
        :value="item.appCode"
        :key="index"
      />
    </el-select>
  </div>
</template>

<style scoped>
.w-full {
  width: 100%;
}
</style>
